import React from 'react';
import styled from 'styled-components';

import useColors from 'hooks/use-colors';
import useTranslation from 'hooks/use-translation';

import { DesktopOnly, MobileOnly } from 'shared/components';
import { Heading1, LargeCapsSubtext } from '../typography';
import { Wrapper } from '../layout';

export default function Hero() {
  const { t } = useTranslation();
  const colors = useColors();
  return (
    <Wrapper>
      <Background />
      <Section>
        <TextCenterContainer>
          <LargeCapsSubtext color={colors.dutchiePlusGreen[35]}>
            {t('dutchiePlus.cannabisEcommerce', 'CANNABIS ECOMMERCE FOR THE ENTERPRISE')}
          </LargeCapsSubtext>
          <Heading1
            color={colors.white}
            title={t('dutchiePlus.yourStoreYourDesign', 'Your Store. Your Design. Our Infrastructure.')}
          >
            <DesktopOnly display='block'>
              {t('dutchiePlus.yourStoreYourDesign', 'Your Store. Your Design. Our Infrastructure.')}
            </DesktopOnly>
            <MobileOnly display='block'>
              {t('dutchiePlus.yourStore', 'Your Store.')}
              <br />
              {t('dutchiePlus.yourDesign', 'Your Design.')}
              <br />
              {t('dutchiePlus.ourInfrastructure', 'Our Infrastructure.')}
            </MobileOnly>
          </Heading1>
        </TextCenterContainer>
      </Section>
    </Wrapper>
  );
}

const Background = styled.div`
  background: ${({ theme }) => theme.colors.dutchiePlusBlue[10]};
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
`;

const Section = styled.section`
  position: relative;
`;

const TextCenterContainer = styled.div`
  display: flex;
  place-items: center;
  flex-direction: column;
  text-align: center;
  p {
    padding-top: 110px;
    max-width: 353px;
    margin: 0 auto;
    color: ${({ theme }) => theme.colors.dutchiePlusGreen[35]};
    ${({ theme }) => theme.breakpoints.down(`sm`)} {
      max-width: 325px;
      padding: 0;
    }
  }
  h1 {
    padding: 28px 0 100px;
    max-width: 820px;
    width: 100%;
    margin: 0 auto;
    ${({ theme }) => theme.breakpoints.down(`sm`)} {
      max-width: 325px;
      padding: 15px 0 50px;
    }
  }
`;
